import _ from "lodash";
import moment from "moment";
import convert from "convert-units";

export const convertToLb = (value) => convert(value).from("kg").to("lb");
export const roundValue = (value) => _.round(value, 1);
export const roundToThousand = (value) => `${_.round(value / 1000, 1)}k`;
export const upperCaseFirstChar = (str) =>
  !!str ? `${str.charAt(0).toUpperCase()}${str.slice(1)}` : "";
export const generateTooltipHtml = (
  athlete,
  cycle,
  idx,
  activeMonth,
  values,
  referAsClients,
  metric,
  unitSelected,
  today
) => {
  const tooltipData = {
    workouts: () => {
      return (
        <>
          {cycle && (
            <div>
              <div>
                <span>
                  <b>Program:</b> {cycle.name}
                </span>
                <span>
                  {cycle && cycle.program && (
                    <span> / {cycle.program.name}</span>
                  )}
                </span>
              </div>
              <div>
                <span>
                  <b>Week: </b>
                </span>
                <span>{cycle.week}</span>
              </div>
              <div>
                <span>
                  <b>Session: </b>
                </span>
                <span>{cycle.session}</span>
              </div>
            </div>
          )}
        </>
      );
    },
    nutrients: () => {
      const { proteins, fats, fibers, carbs } = values || {};
      const proteinsKcal = proteins ? proteins * 4 : 0;
      const carbsKcal = carbs ? carbs * 4 : 0;
      const fatsKcal = fats ? fats * 9 : 0;
      const kcal = proteinsKcal + carbsKcal + fatsKcal;
      return (
        <>
          {values && (
            <div className=" flex flex-col  gap-2 ">
              {proteins ? (
                <span className="block text-[--protein]">
                  P: {roundValue(proteins)}g
                </span>
              ) : null}
              {carbs ? (
                <span className="block text-[--carbs]">
                  C: {roundValue(carbs)}g
                </span>
              ) : null}
              {fats ? (
                <span className="block text-[--fat]">
                  F: {roundValue(fats)}g
                </span>
              ) : null}
              {fibers ? <span>Fiber: {roundValue(fibers)}g</span> : null}
              {kcal > 0 ? <span>Kcal:{roundValue(kcal)}</span> : null}
            </div>
          )}
        </>
      );
    },
    bodyMeasurements: () => {
      const parts = {
        chest: "Chest",
        rightArm: "Right Arm",
        leftArm: "Left Arm",
        neck: "Neck",
        waist: "Waist",
        hips: "Hips",
        leftThigh: "Left Thigh",
        rightThigh: "Right Thigh",
        leftCalf: "Left Calf",
        rightCalf: "Right Calf",
      };
      const unit = unitSelected === "imperial" ? "inch" : "cm";
      return (
        <>
          <div className="data flex flex-wrap items-center gap-2 bg-[--white-05]  rounded-[--border-radius] mt-2 p-2 w-fit max-w-[29rem] ">
            {Object.keys(values).map((key) => {
              if (!parts[key]) return null;
              else {
                const value =
                  unit === "cm"
                    ? values[key]
                    : convert(values[key]).from("cm").to("in");
                return (
                  <span key={parts[key]} className="w-36 text-left">
                    {parts[key]}:{` ${_.round(value, 2)} ${unit}`}
                  </span>
                );
              }
            })}
          </div>
        </>
      );
    },
    readiness: () => {
      return (
        <>
          <div className=" flex flex-col gap-y-2 mt-2 max-w-[27rem]">
            {Object.keys(values).map((key) => {
              if (!values[key]) return null;
              else {
                const text = values[key] && upperCaseFirstChar(String(key));
                return (
                  <span key={values[key]}>
                    {text}:{values[key]}
                  </span>
                );
              }
            })}
          </div>
        </>
      );
    },
    "check-in": () => {
      if (values === "is-late") return <div>{today - (idx + 1)} days late</div>;
    },
    "coach-videos": () => {
      return <div>Type: {upperCaseFirstChar(values)}</div>;
    },
    "coach-notes": () => {
      return <div>Type: {upperCaseFirstChar(values)}</div>;
    },
  };

  return (
    <div>
      <div>
        <span>
          <b>Date: </b>
        </span>
        <span>{moment(activeMonth).add(idx, "days").format("MMM Do")}</span>
      </div>
      <div>
        <span>
          <b>{referAsClients ? "Client" : "Athlete"}: </b>
        </span>
        <span>{athlete.name}</span>
      </div>
      {tooltipData[metric] ? tooltipData[metric]() : null}
    </div>
  );
};
